import React, { memo, forwardRef } from "react";
const SvgCapitalAlpha = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M21.704 23.648l-1.464-3.456h-8.4l-1.464 3.48c-.256.592-.64.888-1.152.888-.336 0-.624-.104-.864-.312-.24-.208-.36-.488-.36-.84 0-.208.064-.448.192-.72l6.384-14.304c.352-.8.864-1.2 1.536-1.2.656 0 1.168.4 1.536 1.2L23.96 22.64c.112.256.168.496.168.72 0 .352-.12.64-.36.864-.24.224-.528.336-.864.336-.544 0-.944-.304-1.2-.912zm-5.64-13.44l-3.336 7.896h6.648l-3.312-7.896z"
      />
    </svg>
  );
});
SvgCapitalAlpha.displayName = "SvgCapitalAlpha";
const MemoForwardRef = memo(SvgCapitalAlpha);
export default MemoForwardRef;
